import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter as Router } from "react-router-dom";

import { GlobalProvider } from "shared/GlobalContext";

import "shared/components/fontawesome";
import "shared/utils/classListPolyfill";
import "admin-lte/dist/css/adminlte.css";

import App from "./App";

// Bootstraps the BI site directly—no dynamic loading needed in per-site repos
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GlobalProvider>
    <Router>
      <App />
    </Router>
  </GlobalProvider>
);
